import {
    PRIZE_WHEEL_REWARDS,
    SpinWheelRewardType,
} from '../../Constants/Reward';
import { Random } from '../../Utility/Random';
import {
    TActionType,
    TransactionType,
} from '../../Utility/Tracking/DataSet/Transaction';
import { trackTransaction } from '../../Utility/Tracking/TrackingHelpers/Transaction';
import { IGameState } from '../Game/IGameState';
import { MissionType } from './IMission';
import { IPlayerState } from './IPlayerState';
import { setCoins, setExtraCards, setLives } from './PlayerInventoryHelper';
import { updateMissionProgress } from './PlayerMissionHelper';
import { updateWheelTimer } from './PlayerTimerHelper';

export function setWheelSpins(
    state: IPlayerState,
    spins: number
): IPlayerState {
    state = {
        ...state,
        wheelSpins: spins,
    };

    return updateWheelTimer(state);
}

export function spinWheel(state: IGameState): IGameState {
    let playerState = state.playerState;
    playerState = setWheelSpins(playerState, playerState.wheelSpins - 1);

    playerState = updateMissionProgress(playerState, MissionType.SPIN_WHEEL, 1);

    const rewardId = Random.getRandomWeighted(
        PRIZE_WHEEL_REWARDS.map(item => item.odds)
    );
    const reward = PRIZE_WHEEL_REWARDS[rewardId];
    switch (reward.type) {
        case SpinWheelRewardType.COINS_1:
        case SpinWheelRewardType.COINS_2:
        case SpinWheelRewardType.COINS_3:
            playerState = setCoins(
                playerState,
                playerState.coins + reward.value
            );
            break;
        case SpinWheelRewardType.CARDS_1:
        case SpinWheelRewardType.CARDS_2:
        case SpinWheelRewardType.CARDS_3:
            playerState = setExtraCards(
                playerState,
                playerState.inventory.extraCards + reward.value
            );
            break;
        case SpinWheelRewardType.LIVES_1:
        case SpinWheelRewardType.LIVES_2:
            playerState = setLives(
                playerState,
                playerState.lives + reward.value
            );
            break;
    }

    playerState.spinWheelTask = [
        ...playerState.spinWheelTask,
        playerState.tasks.pop(),
    ];
    playerState.spinWheelRewardType = reward.type;
    trackTransaction(state, TransactionType.REWARD, TActionType.WHEEL_SPIN);
    state = {
        ...state,
        playerState: playerState,
    };

    return state;
}
